export default __webpack_public_path__ + "static/media/PERSO_4.15c1192f.gif";